import { render, staticRenderFns } from "./DetalheTitulo.vue?vue&type=template&id=4c421c11"
import script from "./DetalheTitulo.vue?vue&type=script&lang=js"
export * from "./DetalheTitulo.vue?vue&type=script&lang=js"
import style0 from "./DetalheTitulo.vue?vue&type=style&index=0&id=4c421c11&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports